import React from 'react';

import type { LinkSectionItem } from '../types';
import { hasImage } from '../utils';
import ImageLinkSectionListItem from './ImageLinkSectionListItem';
import InlineTextLinkSectionListItem from './InlineTextLinkSectionListItem';
import { TextLinkSectionListItem } from './TextLinkSectionListItem';

interface LinkSectionListItemProps {
  index: number;
  item: LinkSectionItem;
  isInline?: boolean;
}

const LinkSectionListItem = ({ item, isInline, ...props }: LinkSectionListItemProps) => {
  if (hasImage(item)) {
    return <ImageLinkSectionListItem item={item} isInline={isInline} {...props} />;
  } else if (isInline) {
    return <InlineTextLinkSectionListItem item={item} {...props} />;
  }

  return <TextLinkSectionListItem item={item} {...props} />;
};

export default LinkSectionListItem;
